export default function CostAvoidanceNav() {
  return(
    <h1>Hi from CostAvoidanceNav</h1>
  )
}